export default __webpack_public_path__ + "static/media/cibss.1a72daaa.svg";